<template>
  <div class="card" ref="instanceUuid">
    <div class="box widget-social nice-font pt-2 pb-2" :class="componentStyle">
      <div v-if="isLoading">
        <loader-skeleton :widgetInfo="content"></loader-skeleton>
      </div>
      <div class="menu-overlay">
        <Button v-if="paramChangeState" icon="pi mif-wrench" :class="'p-button-rounded p-link mr-1 mt-1 fg-lightAmber'" @click="multiParamChange" v-tooltip="'Werte ändern'"></Button>
        <Button v-if="!isEditMode" icon="pi pi-sync" :class="'p-button-rounded p-link mr-1 mt-1 fg-lightAmber' + isLoadingCss" @click="loadParameterValues" v-tooltip="'Aktualisieren'"></Button>
        <Button v-if="isEditMode" icon="pi pi-bars" class="p-button-rounded p-link mr-1 mt-1 fg-lightAmber handle" title="Bewegen"></Button>
        <Button icon="pi pi-ellipsis-h" class="p-button-rounded p-link mr-1 mt-1 fg-lightAmber" @click="toggle" v-tooltip="'Menü'"></Button>
        <Menu :id="'boxMenu_' + 1" ref="menu" :model="items" :popup="true" :baseZIndex="100" />
      </div>
      <div v-if="!isLoading && nodeData.length > 0 && tableData.length > 0">
        <div class="info flex flex-column mb-2 fg-lime">
          <!-- <p class="text-left"><i class="mif-table"></i><span class="pl-1 mt-1">{{ titleName }}</span></p> -->
          <p class="text-left"><i class="mif-chart-dots"></i><span class="pl-1 mt-1">{{ titleName }}</span><span v-if="dateTime" class="pl-1 mt-1 fg-lightPink">⚡ {{ paramLabel }} <span v-if="hoursOffset > 0" class="text-xs">(-{{ daysOffset }} Tage)</span></span></p>
        </div>
        <VueApexCharts id="chartVal1" type="area" :options="chartOptionsFin" v-bind:series="chartSeriesFin" :height="instanceSize.height" />
        <div v-if="false">
          <div v-for="chart in chartSeriesFin" :key="chart.key" :item="chart" class="flex justify-content-center align-items-center p-0 flex-wrap mb-1">
            <div class="flex justify-content-center align-items-center p-0 mr-2">
              <span class="person-tag fg-steel  p-1">[{{chart.department}}] {{ chart.name }}</span>
            </div>
            <div class="flex justify-content-center align-items-center p-0 mr-2">
              <span class="person-tag fg-amber  p-1">Minimum: <span class="fg-lightAmber">{{ chart.valueMin }}</span></span>
            </div>
            <div class="flex justify-content-center align-items-center p-0 mr-2">
              <span class="person-tag fg-amber  p-1">Maximum: <span class="fg-lightAmber">{{ chart.valueMax }}</span></span>
            </div>
            <div class="flex justify-content-center align-items-center p-0 mr-2">
              <span class="person-tag fg-amber  p-1">Mittelwert: <span class="fg-lightAmber">{{ chart.valueAvg }}</span></span>
            </div>
          </div>
        </div>
        <div class="flex justify-content-center align-items-center p-0 card ml-3 mr-3 mb-3">
          <div class="flex justify-content-center align-items-center mr-1">
            <Button label="<48h" class="p-button-text fg-lightBrown" @click="timeTravel(-48)" />
            <Button label="<24h" class="p-button-text fg-lightBrown" @click="timeTravel(-24)" />
            <Button label="<12h" class="p-button-text fg-lightBrown" @click="timeTravel(-12)" />
            <Button label="<1h" class="p-button-text fg-lightBrown" @click="timeTravel(-1)" />
          </div>
          <div class="flex justify-content-center align-items-center mr-1">
            <Button label="jetzt" class="p-button-text fg-lightPink" @click="timeTravel(0)" />
          </div>
          <div class="flex justify-content-center align-items-center">
            <Button label="1h>" class="p-button-text fg-lightGreen" @click="timeTravel(1)" />
            <Button label="12h>" class="p-button-text fg-lightGreen" @click="timeTravel(12)" />
            <Button label="24h>" class="p-button-text fg-lightGreen" @click="timeTravel(24)" />
            <Button label="48h>" class="p-button-text fg-lightGreen" @click="timeTravel(48)" />
          </div>
        </div>
      </div>

      <div v-if="entryDialog === true">
        <dialog-opc-tree v-bind:showDialog="entryDialog" :dialogObj="ioObj" v-bind:dialogData="ioDialogData"
          @entrySave="
            ($value) => {
              changeVal($value);
            }
          " @entryAbort="hideDialog()"></dialog-opc-tree>
      </div>

      <div v-if="dialogState.date === true">
        <dialog-date-select v-bind:showDialog="dialogState.date" :dialogObj="ioObj" :dateTime="dateTime" v-bind:dialogData="ioDialogData"
          @entrySave="
            ($value) => {
              changeDate(null, $value);
            }
          " @entryAbort="hideDialog('date')"></dialog-date-select>
      </div>
    </div>
  </div>

  <Dialog v-model:visible="diagMultiChange" :closable="false" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '450px' }" :modal="true" class="p-fluid">
    <template #header>
      <p class="nice-font"><i class="mif-wrench"></i><span class="pl-1 mt-1">MultiChange</span><span class="pl-1 mt-1 fg-lightPink">⚡ {{ paramLabel }}</span></p>
    </template>
    <div @keydown.esc="hideMultiChange" @keydown.enter="saveMultiChange">
      <Panel>
        <div class="flex pb-3 justify-content-center">
          <Avatar v-for="param in selectedParameters" :key="param.identifier" :item="param" :label="param.department" v-tooltip="`${param.moduleLabel} - ${param.moduleDescription}`" class="mr-1 font-semibold bg-lightLime fg-crimson cursor-pointer" />
        </div>
        <div class="grid p-fluid">
          <div class="col-12 pl-5 pr-5">
            <div v-if="changingParameters[0].unit === '#BOOL'" class="text-center mt-2 mb-2">
              <InputSwitch v-model="changingParameters[0].value" /><span class="ml-2">Ein/Aus</span>
            </div>
            <div v-else-if="changingParameters[0].unit === '#HMS'" class="p-inputgroup">
              <InputMask id="changingValueField" ref="changingValueField" mask="99:99:99" placeholder=""
                slotChar="hh:mm:ss" v-model="changingParameters[0].value" autofocus @focus="focusElement"
                class="nice-font inputtext-param text-center text-5xl" />
                <span class="p-inputgroup-addon nice-font text-3xl">{{ changingParameters[0].unitStr }}</span>
            </div>
            <div v-else class="p-inputgroup">
              <InputNumber id="changingValueField" ref="changingValueField"
                v-model="changingParameters[0].value" autofocus @focus="focusElement"
                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                inputClass="nice-font inputtext-param text-center text-5xl"  />
              <!-- <InputText v-model="changingValue" :ref="'e' + 'param.index'" class="nice-font inputtext-param text-center text-5xl"
              @focus="focusField('e' + 'param.index')" @blur="blurField" /> -->
              <span class="p-inputgroup-addon nice-font text-3xl">{{ changingParameters[0].unitStr }}</span>
            </div>
          </div>
        </div>
      </Panel>
    </div>
    <template #footer>
      <Button label="Abbrechen" icon="pi pi-times" class="p-button-text" @click="hideMultiChange" />
      <Button label="Speichern" icon="pi pi-check" class="p-button-text" @click="saveMultiChange" />
    </template>
  </Dialog>
</template>

<script>
import { defineComponent } from "vue";
import store from "@/store";
import { mapGetters, mapActions } from 'vuex';
import SocketioService from "@/services/socketioService.js";
import helpers from "@/helpers";
import { parseNode, splitNodeId, setOpcValueToast, combineRedisHash, isEven } from "@/helpers";
import dialogOpcTree from '@/components/dialog/dialog_opcTree.vue';
import dialogDateSelect from '@/components/dialog/dialogDateSelect.vue';
import VueApexCharts from "vue3-apexcharts";
// import _ from 'lodash';

export default defineComponent({
  name: "widgetPanelCharts",
  setup() { },
  emits: ["entrySave", "entryDuplicate", "entryDelete"],
  props: {
    content: {
      type: null,
      required: false,
    },
    dragObj: {
      type: null,
      required: false,
    },
    valueObj: {
      type: null,
      required: true,
    },
    dataObj: {
      type: null,
      required: false,
    },
    styleObj: {
      type: null,
      required: false,
    },
    createdLayout: {
        type: Boolean,
        required: false,
    },
    readyLayout: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    // nodeEntry: {},
    dialogOpcTree,
    dialogDateSelect,
    VueApexCharts
  },
  watch: {
    createdLayout() {
        this.watchCreatedLayout();
    },
    readyLayout() {
      this.watchLayout();
    },
    '$store.getters.getPageData.editMode': function () {
      this.checkEditMode();
    },
    chartNodesLoaded() {
      // console.log('changedate')
      if (this.chartNodesLoaded) {
        this.changeDate('24h');
      }
    },
    chartSeriesLoaded() {
      if (this.chartSeriesLoaded) {
        // console.log('ARRAY SORT');
        this.chartSeries.sort((a, b) => a.index - b.index);
        this.chartOptions.yaxis.sort((a, b) => a.index - b.index);
        this.chartOptions.tooltip.y.sort((a, b) => a.index - b.index);
        // console.log(this.nodeData);
        // console.log(this.chartSeries);
        this.chartOptionsFin = this.chartOptions;
        this.chartSeriesFin = this.chartSeries;
        this.loading = false;
      }
    }
  },
  data() {
    return {
      loading: false,
      loadActive: false,
      nodeData: [],
      nodeDataOld: [],
      selectedParameters: [],
      changingParameters: [],
      changingValue: null,
      changingUnit: null,
      editingRows: [],
      entryDialog: false,
      dateDialog: false,
      dialogState: {
        date: false,
      },
      hoursOffset: 0,
      dateTime: {
        start: 0,
        end: 0,
        format: null,
        window: null,
      },
      ioDialogData: {},
      nodes: [],
      ioObj: [],
      paramFiltered: [],
      paramEntry: {
        label: null,
        unit: null,
      },
      node: null,
      map: null,
      diagMultiChange: false,
      config_io: null,
      editField: '',
      items: [],
      items1: [
        {
          label: 'Datum wählen',
          icon: 'pi pi-calendar',
          command: () => {
            this.openDialog('date');
          },
        },
        {
          label: '12h',
          icon: 'pi pi-clock',
          command: () => {
            this.changeDate('12h');
          },
        },
        {
          label: '24h',
          icon: 'pi pi-clock',
          command: () => {
            this.changeDate('24h');
          },
        },
        {
          label: '48h',
          icon: 'pi pi-clock',
          command: () => {
            this.changeDate('48h');
          },
        },
        {
          label: '1 Woche',
          icon: 'pi pi-clock',
          command: () => {
            this.changeDate('7d');
          },
        },
        {
          label: '1 Monat',
          icon: 'pi pi-clock',
          command: () => {
            this.changeDate('30d');
          },
        },
        {
          label: '2 Monate',
          icon: 'pi pi-clock',
          command: () => {
            this.changeDate('2m');
          },
        },
        {
          label: '1 Jahr',
          icon: 'pi pi-clock',
          command: () => {
            this.changeDate('1y');
          },
        },
        {
          label: 'Werte-Auswahl',
          icon: 'pi pi-cog',
          command: () => {
            // this.editEntry(this.content);
            this.editEntry(this.dataObj);
          },
        }
      ],
      items2: [
        {
          separator: true,
        },
        {
          label: 'Einstellungen',
          icon: 'pi pi-cog',
          command: () => {
            this.editEntry(this.dataObj);
          },
        },
        {
          label: 'Duplizieren',
          icon: 'pi pi-clone',
          command: () => {
            this.duplicateEntry();
          },
        },
        {
          label: 'Löschen',
          icon: 'pi pi-times',
          command: () => {
            this.deleteEntry();
          },
        },
      ],
      chartNodes: [],
      chartSeriesFin: [],
      chartSeries: [],
      chartOptionsFin: {},
      chartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          defaultLocale: 'de',
          locales: [{
            name: 'de',
            options: {
              months: ['Jänner', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
              shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
              days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
              shortDays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
              toolbar: {
                download: 'Download SVG',
                selection: 'Auswahl',
                selectionZoom: 'Auswahl Zoom',
                zoomIn: 'Zoom In',
                zoomOut: 'Zoom Out',
                pan: 'Panning',
                reset: 'Reset Zoom',
              }
            }
          }],
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            show: true,
            autoSelected: 'zoom',
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true | '<img src="/static/icons/reset.png" width="20">',
              customIcons: []
            },
            export: {
              csv: {
                headerCategory: `Date;Time`,
                headerValue: `value`,
                columnDelimiter: ';',
                dateFormatter: function(timestamp) {
                  return new Date(timestamp).toLocaleString('de-AT');
                },
              },
              svg: {
                filename: undefined,
              },
              png: {
                filename: undefined,
              }
            },
          },
          brush: {
            enabled: false,
            target: 'chartVal1',
            autoScaleYaxis: true
          },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 400,
            animateGradually: {
                enabled: true,
                delay: 40
            },
            dynamicAnimation: {
                enabled: true,
                speed: 300
            }
          },
          dropShadow: {
          enabled: false,
          enabledSeries: [0],
          top: -2,
          left: 2,
          blur: 5,
          opacity: 0.1
        }
        },
        theme: {
          palette: 'palette1',
        },
        // colors: ['#ede06e', '#E91E63'],
        stroke: {
          curve: 'smooth',
          width: 2
        },
        grid: {
          show: true,
          position: 'back',
          borderColor: "#555",
          clipMarkers: false,
          xaxis: {
            lines: {
              show: true
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0,
        },
        fill: {
          type: 'gradient',
          gradient: {
            type: "vertical",
            shadeIntensity: 0,
            inverseColors: false,
            opacityFrom: 0.4,
            opacityTo: 0,
          },
        },
        yaxis: [],
        xaxis: null,
        tooltip: {
          shared: true,
          theme: 'dark',
          x: {
            show: true,
            formatter: function (value) {
              return new Date(value).toLocaleString('de-AT');
            },
          },
          y: [],
          items: {
            display: 'flex',
          },
        },
        legend: {
          fontSize: '12px',
          fontWeight: 400,
          fontFamily: 'Arial',
          labels: {
            useSeriesColors: true
          }
        }
      },
    };
  },
  computed: {
    ...mapGetters({
      editMode: 'getEditMode',
      getNodeWidget: 'getNodeWidget',
      getOneDepartment: 'types/getOneDepartment',
      getOneCategory: 'types/getOneCategory',
      getStyleColors: 'getStyleColors',
      getStylePatterns: 'getStylePatterns',
      getModules: 'opcua/getModules',
      getModule: 'opcua/getModule',
      getNode: 'opcua/getNode',
      getModuleFetched: 'opcua/getModuleFetched',
      isMaster: 'auth/isMaster',
    }),
    isLoading: function() {
        if (this.loading || !this.chartNodesLoaded || !this.chartSeriesLoaded) return true;
        // if (this.loading) return true;
        return false;
    },
    // componentStyle: function () {
    //     if (this.content.style && this.content.style !== 'standard') {
    //         return 'box ptrn-' +  this.content.style.pattern + ' bg-' + this.content.style.background + ' fg-' + this.content.style.foreground;
    //     } else {
    //         return '';
    //     }
    // },
    componentStyle: function () {
        if (this.content.style && this.content.style !== 'standard') {
            let background = `bg-${this.content.style.background}`;
            return `box ptrn-${this.content.style.pattern} ${background} fg-${this.content.style.foreground}`;
        } else {
            return '';
        }
    },
    isEditMode: function () {
      if(this.$store.getters.getPageData.editMode) {
        return true;
      } else {
        return false;
      }
    },
    isLoadingCss: function () {
      if (this.loading) {
          return ' pi-spin';
      } else {
          return ' p-button-plain';
      }
    },
    paramChangeState() {
      // console.log(this.selectedParameters);
      if (this.selectedParameters.length > 0 && !this.isEditMode) {
        return true;
      } else {
        return false;
      }
    },
    titleName: function () {
      if (this.dragObj.label === "") {
        if (this.dataObj[0] && this.dataObj[0].children) {
          return this.dataObj[0].children.key;
        } else {
          return "";
        }
      } else {
        return this.dragObj.label;
      }
    },
    paramLabel: function () {
      return `${this.dateTime.start.toLocaleString('de-AT')} - ${this.dateTime.end.toLocaleString('de-AT')}`;
      // if (this.nodeData[0] !== undefined && this.nodeData[0].description) {
      //   return this.nodeData[0].description;
      // } else {
      //   return this.$store.getters.getNoval;
      // }
    },
    moduleHash: function () {
      if (this.content.data && this.content.data.displayName) {
        return `*${this.content.data.displayName}*`;
      }
      return null;
    },
    instanceUuid: function () {
      if (this.content.i && typeof(this.content.i) === 'string') {
        return this.content.i;
      } else return 'instance';
    },
    instanceSize: function () {
      let size = {
        height: 0,
        width: 0
      };
      if (this.instanceUuid) {
        size.height = this.$refs.instanceUuid.clientHeight;
        size.height = size.height * 0.85;
        size.width = this.$refs.instanceUuid.clientWidth;
      }
      return size;
    },
    tableData: function () {
      if (Array.isArray(this.nodeData) && this.nodeData.length > 0) {
        let entries = [];
        this.nodeData.forEach((entry) => {
          if (entry.key) {
            const splittedId = splitNodeId(entry.key);
            const key = `${entry.server}@${splittedId.identifier}`;
            const node = this.getNode(key);
            if (entry.labelSpecial !== undefined) node.label = entry.labelSpecial;
            if (node.identifier) entries.push(node);
          }
        });
        if (entries.length > 0) {
          return entries;
        }
      }
      return [];
    },
    chartNodesLoaded: function () {
      // console.log(this.chartNodes.length, this.nodeData.length, this.chartSeries.length);
      if (this.nodeData.length > 0 && this.chartNodes.length === this.nodeData.length) return true;
      // if (this.nodeData.length > 0 && this.chartNodes.length === this.nodeData.length && this.chartSeries.length === this.nodeData.length) return true;
      else return false;
    },
    chartSeriesLoaded: function () {
      if (this.chartSeries.length > 0 && this.chartSeries.length === this.nodeData.length) return true;
      else return false;
    },
    daysOffset: function () {
      const d = this.hoursOffset/24;
      return parseFloat(d.toFixed(1));
    },
  },
  created() {
    // if (!this.getModuleFetched(this.moduleHash)) {
      // const moduleHash = `${module.source.server}@${module.source.identifier}.*`;

    // } else {
    //     this.loading = false;
    // }
    this.loadParameterValues();
  },
  mounted() {
    this.checkEditMode();
  },
  methods: {
    ...mapActions({
        loadNode: 'opcua/loadNode',
        loadNodeOnce: 'opcua/loadNodeOnce',
        loadModule: 'opcua/loadModule',
        setNodesFull: 'opcua/setNodesFull',
        setModuleFetched: 'opcua/setModuleFetched',
    }),
    loadParameterValues() {
      // this.loading = true;
      this.chartNodes = [];
      this.nodeData = [];
      this.hoursOffset = 0;
      if (Array.isArray(this.content.data) && this.content.data.length > 0) {
        this.nodeData = [ ...this.content.data ];

        this.nodeData.forEach((node) => {
          const splittedId = splitNodeId(node.key);
          const key = combineRedisHash(node.server, splittedId.identifier);
          this.loadNodeOnce(key).then(() => {
            const nodeObj = this.getNode(key);
            this.chartNodes.push(nodeObj);
            // this.chartNodes.push(result[0]);
          });
          
        });
      }
    },
    getModuleValue(schemeEntry) {
        const key = `${this.moduleHash}.${schemeEntry}`;
        return this.getNode(key);
    },
    getModuleValueStr(schemeEntry) {
        const key = `${this.moduleHash}.${schemeEntry}`;
        const node = this.getNode(key);
        if (typeof node.unit === 'string' && node.unit.length > 0) {
            return `${node.value}${node.unit}`;
        }
        return `${node.value}`;
    },
    getModuleValues(schemeEntries) {
      if (Array.isArray(schemeEntries)) {
        let entries = [];
        schemeEntries.forEach((entry) => {
          const splittedId = splitNodeId(entry.key);
          const key = `${entry.server}@${splittedId.identifier}`;
          const node = this.getNode(key);
          entries.push(node);
        });
        if (entries.length > 0) {
          return entries;
        }
      }
      // if (Array.isArray(schemeEntries) && schemeEntries.length > 0) {
      //   let entries = [];
      //   schemeEntries.forEach((entry) => {
      //     // console.log(entry);
      //     const key = `${entry.server}@${entry.identifier}`;
      //     const node = this.getNode(key);
      //     if (node) {
      //       if (node.child0) {
      //         try {
      //           const child = JSON.parse(node.child0);
      //           if (child.index >= 0) {
      //             node.index = (child.index+1).toString();
      //           } else node.index = '';
      //         } catch {
      //           node.index = '';
      //         }
      //       } else {
      //         node.index = '';
      //       }
      //       entries.push(node);
      //     }
      //   });
      //   if (entries.length > 0) {
      //     entries.sort((a, b) => a.department.localeCompare(b.department));
      //     // console.log(entries);
      //     return entries;
      //   }
      // }
        return null;
    },
    formatValue(node) {
      if (node.unit === '#BOOL') {
        if (node.value === true) return '🟢 Ein';
        else return '🔴 Aus';
      }
      else return node.value;
    },
    watchCreatedLayout() {
      // // this.loading = true;
      // this.loading = true;
      // if (this.content.data && this.content.data.displayName) {
      //   SocketioService.getRedisNodesParam(`*${this.content.data.displayName}*`, (err, response) => {
      //     if (err || !response) {
      //         console.log(`[ENATWIDGET] error fetching params: ${err}`);
      //     }
      //     else {
      //         if (Array.isArray(response) && response.length > 0) {
      //             let tmpNodes = [];
      //             let tmpNodesFilter = [];
      //             tmpNodes = JSON.parse(JSON.stringify(response));
      //             tmpNodesFilter = tmpNodes.filter(item => item.moduleScheme === this.content.data.moduleScheme && item.displayName === this.content.data.displayName);
      //             this.setNodesFull(tmpNodesFilter);
      //             this.nodeData = [ ...tmpNodesFilter ];
      //             // this.nodeDataOld = JSON.parse(JSON.stringify(this.nodeData));
      //             // console.log(this.nodeData);
      //         }
      //     }
      //   }).then(() => {
      //       this.loading = false;
      //   }); 
      // }
    },
    watchLayout() {
    },
    checkEditMode() {
      if (this.$store.getters.getPageData.editMode) {
        this.items = [...this.items1, ...this.items2];
      } else {
        this.items = [...this.items1];
      }
    },
    loadMap() {
      if (this.dataObj) {
        const map = new Map(store.getters.getMapValues);
        let map2 = new Map();
        let metadata = null;
        let displayNameArrPos = null;
        console.log(">>> DATAOBJ:", this.dataObj);
        this.dataObj.forEach((parameter) => {
          console.log(">>> DATAOBJ_ELM:", parameter.children);
          for (let [key, element] of map) {
            // if (element.key === parameter.children.key) {
            displayNameArrPos = element.key.indexOf('[');
            if (displayNameArrPos === -1) {
              if (element.key === parameter.children.key) {
                console.log(">>> FOUND DATAOBJ:", key, element);
                // metadata = store.getters.getValue(element.id).metadata;
                metadata = store.getters.getValue(element.parent).metadata;
                console.log(">>> METADATA:", metadata);
                // map2.set(element.uuid, element);
                map2.set(element.uuid, this.getMapValue(element.uuid));
              }
            } else {
              for (let i=0; i<8; i++) {
                const index = i.toString();
                const readIndex = (i+1).toString();
                const newKey = [parameter.children.key.slice(0, displayNameArrPos+1), index, parameter.children.key.slice(displayNameArrPos+1)].join('');
                if (element.key === newKey) {
                  // metadata = store.getters.getValue(element.id).metadata;
                  metadata = store.getters.getValue(element.parent).metadata;
                  console.log(">>> METADATA:", metadata);
                  // map2.set(element.uuid, element);
                  let storeMap = { ...this.getMapValue(element.uuid)};
                  let description = "[" + readIndex + "] " + storeMap.description;
                  storeMap.description = description;
                  map2.set(element.uuid, storeMap);
                }
              }
            }
            
          }
          const map3 = new Map([...map2].sort((a, b) => a[1].department.localeCompare(b[1].department)));
          console.log(">>> MAP2 (unsorted):", map2);
          console.log(">>> MAP3 (sorted):", map3);
          // this.map = new Map(map3);
          this.map = new Map(map3);
        });
      }
    },
    updateMap() {
      if (this.node && this.node.size > 0) {
        for (let [key, element] of this.node) {
            const child = store.getters.getMapValue(element.uuid);
            this.node.set(key, {...child, value: child.value});
        }
      }
    },
    currentMap() {
      let map = new Map();
      if (this.node && this.node.size > 0) {
        for (let [key, element] of this.node) {
            const child = store.getters.getMapValue(element.uuid);
            map.set(key, {...child, value: child.value});
        }
        return map;
      }
      return null;
    },
    updateMapValues() {
      for (let [key, element] of this.map) {
        store.getters.getMapValue(element.uuid);
        console.log(">>> UPDATE:", key, element);
      }
    },
    getParameter(lvl1, lvl2, index) {
        let parameter = null;
        if (!lvl1) return false;
        if (!lvl2) lvl2 = '';
        if (!isNaN(index)) {
            parameter = this.node.get(lvl1 + '[' + index + '].' + lvl2);
        } else {
            parameter = this.node.get(lvl1 + lvl2);
        }
        return parameter;
    },
    toggle(event) {
      this.$refs.menu.toggle(event);
      // this.getParameterStatusIOTree();
      // this.getOPCAppTree();
    },
    openDialog(name) {
      if (name) {
        this.dialogState[name] = true;
      } else {
        this.entryDialog = true;
      }
    },
    hideDialog(name) {
      if (name) {
        this.dialogState[name] = false;
      } else {
        this.entryDialog = false;
        this.submitted = false;
      }
      // clearInterval(this.intval_Value);
      // this.getUserList();
    },
    hideMultiChange() {
      this.selectedParameters = [];
      this.diagMultiChange = false;
    },
    saveMultiChange() {
      if (this.selectedParameters.length > 0 && this.changingParameters.length > 0) {
        const saveArray = [];
        let tempArray = JSON.parse(JSON.stringify(this.selectedParameters));
        if (Array.isArray(tempArray) && tempArray.length > 0) {
          tempArray.forEach((entry) => {
            if (entry.value !== this.changingParameters[0].value) {
              entry.value = this.changingParameters[0].value;
              saveArray.push(parseNode(entry, true));
            }
          });
          if (saveArray.length > 0) {
            SocketioService.setOpcValue(saveArray, (err, response) => {
              if (err) {
                  console.log(err);
              } else {
                  console.log(response);
                  setOpcValueToast(response, this.$root);
                  this.selectedParameters = [];
                  this.diagMultiChange = false;
              }
            });
          } else {
            setOpcValueToast(null, this.$root);
            this.selectedParameters = [];
            this.diagMultiChange = false;
          }
        }
      } else {
        this.$toast.add({
            severity: 'warn',
            summary: 'Keine Änderungen!',
            detail: 'Es wurde kein einziger Wert geändert!',
            life: 3000,
        });
        this.selectedParameters = [];
        this.diagMultiChange = false;
      }
    },
    editEntry(ioData) {
      // this.ioDialogData = { ...ioData };
      // this.getUserList();
      const _obj = JSON.parse(JSON.stringify(ioData));
      for (let i = 0; i < _obj.length; i++) {
        this.ioObj[i] = store.getters.getValue(_obj[i].id);
      }
      // this.ioObj = store.getters.getValue(_obj.data.id);
      // const _obj = { ...ioData };
      this.ioDialogData = { ...this.content };
      // this.selectedKey[_obj.data.id] = true;

      console.log(this.ioDialogData);
      console.log(this.ioObj);

      // this.expandedKeys[this.nodes[0].key] = true;

      this.entryDialog = true;
      // this.intval_Value = setInterval(this.updateOpenValue, 1000);
    },
    changeVal(ioData) {
      this.entryDialog = false;
      this.submitted = false;
      this.$emit("entrySave", ioData);
      this.nodes = [];
      // this.getNodes();
      this.ioDialogData = ioData;
    },
    duplicateEntry() {
      this.$emit("entryDuplicate", this.content);
      // this.resetDialogData();
    },
    deleteEntry() {
      this.$emit("entryDelete", this.content);
      // this.resetDialogData();
    },
    getNodes() {
      // let arr = [];
      if (this.dataObj !== undefined) {
        this.nodes = [];
        this.dataObj.forEach((element) => {
          // store.dispatch("getValues", element.id);
          this.nodes.push(store.getters.getValue(element.id));
          // arr.push(store.dispatch("getValues", element.id));
          // console.log("Registered node: ", store.getters.getValue(element.id));
        });
      } else return undefined;
    },
    getValue(_id) {
      var index = this.valueObj.findIndex((x) => x._id === _id);
      if (index === -1) {
        // this.values.push(vars);
        console.log("NOT FOUND");
      } else {
        // this.values[index] = vars;
        return this.valueObj[index];
      }
    },
    getParameterConfigIO() {
      const response = [...this.nodeEntries];
      if (this.config_io !== null) {
        this.config_io = response;
        const _cat = helpers.findIndexByName(this.config_io.types_parameters, this.ioDialogData.data[0].category);
        console.log(this.config_io.types_parameters[_cat]);
      }
      // SocketioService.getServerData("config", 'io', (err, response) => {
      //   this.config_io = response;
      //   const _cat = helpers.findIndexByName(this.config_io.types_parameters, this.ioDialogData.data[0].category);
      //   console.log(this.config_io.types_parameters[_cat]);
      // });
    },
    filterParameters() {
      this.loading = true;
      // this.paramFiltered = [];
      // SocketioService.getServerData("status", "io", (err, response) => {
      //   if (!err) {
      //     const _obj = JSON.parse(JSON.stringify(response));
      //     let result = null;
      //     result = Object.entries(_obj)
      //       .filter(([, value]) => value.metadata.category === this.ioDialogData.data[0].category)
      //       .map(([, value]) => value);

      //     this.paramFiltered = [];
      //     result.forEach((element) => {
      //       if (Array.isArray(element.children)) {
      //         element.children.forEach((subElement, index) => {
      //           if (subElement.displayName === this.ioDialogData.data[0].children.key) {
      //             this.paramEntry.label = subElement.label;
      //             this.paramEntry.unit = subElement.unit;
      //             subElement._id = element._id;
      //             subElement.index = index;
      //             subElement.metadata = element.metadata;
      //             // console.log(subElement);
      //             this.paramFiltered.push(subElement);
      //           }
      //         })
      //       }
      //     });
      //     this.paramFiltered.sort((a, b) => a.metadata.department.localeCompare(b.metadata.department));
      //     this.loading = false;
      //   }
      //   // this.loading = false;
      // });
      this.paramFiltered = [];
      const node = [...this.nodeEntries];
      node.forEach((element) => {
        if (element) {
          if (Array.isArray(element.children)) {
            element.children.forEach((subElement, index) => {
              if (subElement !== null) {
                // if (subElement.displayName === this.ioDialogData.data[0].children.key) {
                if (subElement.parameter === this.ioDialogData.data[0].children.key) {
                  let filteredSubElement = {};
                  this.paramEntry.label = subElement.label;
                  this.paramEntry.unit = subElement.unit;
                  filteredSubElement = {...subElement};
                  filteredSubElement._id = element._id;
                  filteredSubElement.index = index;
                  filteredSubElement.metadata = element.metadata;
                  // console.log(subElement);
                  this.paramFiltered.push(filteredSubElement);
                }
              }
            })
          }
        }
      });
      this.paramFiltered.sort((a, b) => a.metadata.department.localeCompare(b.metadata.department));
      this.loading = false;
    },
    focusElement2(element) {
      // console.log(element);
      this.$refs[element].$el.focus();
    },
    focusElement(event) {
      if (event !== undefined) {
        event.target.select();
      }
    },
    focusField(name) {
      this.editField = name;
      this.$nextTick(() => this.$nextTick(() => this.focusElement(name)));
    },
    blurField() {
      this.editField = '';
    },
    showField(name) {
      return (this.editField == name)
    },
    multiParamChange() {
      // console.log(this.selectedParameters);
      const _obj = JSON.parse(JSON.stringify(this.selectedParameters));
      console.log(_obj);
      if (Array.isArray(_obj) && _obj.length > 0) {
        if (_obj[0].writeable === "true") {
          this.changingParameters = _obj;
          this.changingValue = helpers.paramValue(this.changingParameters[0], 'value');
          this.changingUnit = helpers.paramValue(this.changingParameters[0], 'unit');
          this.diagMultiChange = true;
        } else {
          this.$toast.add({ severity: 'warn', summary: 'Wert(e) nicht änderbar!', detail: 'Es handelt sich um keinen Einstellwert.', life: 3000 });
        }
      }
    },
    paramValue(paramEntry, mode) {
      return helpers.paramValue(paramEntry, mode);
    },
    // titleName: function () {
    //   if (this.dragObj.label === "") {
    //     return "";
    //   } else {
    //     return this.dragObj.label + ' ⚡';
    //   }
    // },
    // paramLabel: function () {
    //   if (this.paramEntry.label !== undefined) {
    //     return this.paramEntry.label;
    //   } else {
    //     return "!!!";
    //   }
    // },
    paramValueStr(paramEntry) {
      if (paramEntry !== undefined) {
        if (paramEntry.value !== undefined && paramEntry.unit !== undefined) {
          // if (paramEntry.unit === '#BOOL') {
          //   if (paramEntry.value === true) {
          //     return '🟢 Ein';
          //   } else {
          //     return '🔴 Aus';
          //   }
          // } else if (paramEntry.unit === '#HMS') {
          //   return helpers.hms(paramEntry.value, false);
          // } else {
          //   if (paramEntry.factor > 1) {
          //     return (paramEntry.value/paramEntry.factor).toFixed(1);
          //   } else {
          //     return paramEntry.value;
          //   }
          // }
          return paramEntry.value;
        } else {
          return "!!!";
        }
      }
    },
    renderChart(node, start, end, format) {
      let dateStart = new Date();
      let dateEnd = new Date();
      // dateStart.setTime(this.dateTimeSelectStart);
      // dateEnd.setTime(this.dateTimeSelectEnd);
      dateStart.setTime(start);
      dateEnd.setTime(end);
      this.chartOptions.xaxis.min = dateStart;
      this.chartOptions.xaxis.max = dateEnd;

      const splittedId = splitNodeId(node.key);
      const key = combineRedisHash(node.server, splittedId.identifier);
      const fullNode = this.getNode(key);
      if (!fullNode.cumulative) node.cumulative = false;
      else {
        if (fullNode.cumulative === true) node.cumulative = true;
        else node.cumulative = false;
      }

      // this.loading = true;

      const request = {
        hash: key,
        // hash: combineRedisHash(node.server, node.identifier),
        server: node.server,
        identifier: splittedId.identifier,
        startTime: dateStart,
        endTime: dateEnd,
        format: format,
        cumulative: node.cumulative,
        window: this.dateTime.window
        // cumulative: true
        // startTime: dateDayAgo,
        // endTime: dateNow
      }
      SocketioService.getChart(request, (err, response) => {
        if (!err && response !== null && response.length > 0) {
          // console.log(response);
          // this.io_data = [ ...response ];
          this.chartOptions.xaxis.categories = [];
          // this.chartSeries[0].data = [];
          const tmpObj = {
              name: ``,
              connectNulls: true,
              data: []
          };
          let scaledObj;

          response.forEach((entry) => {
            const newObj = JSON.parse(JSON.stringify(fullNode));
            newObj.value = entry._value;
            if (typeof newObj.value === 'boolean') {
              newObj.unit = "";
              if (newObj.value === true) newObj.value = 1;
              else newObj.value = 0;
            }
            if (newObj.unit === '#HMS') {
              newObj.unit = "";
            }
            scaledObj = parseNode(newObj);
            
            if (typeof scaledObj.value !== 'number') scaledObj.value = Number(scaledObj.value);
            this.chartOptions.xaxis.categories.push(entry._time);
            // this.chartOptions.yaxis.title.text.push(scaledObj.unitStr);

            // this.chartSeries[0].data.push(scaledObj.value);
            // tmpObj.data.push(`${scaledObj.value} ${scaledObj.unitStr}`);
            tmpObj.data.push(`${scaledObj.value}`);
          });

          // console.log(tmpObj);

          let opposite = false;
          if (isEven(this.chartOptions.yaxis.length)) opposite = true;

          const ydataset = {
            index: node.index,
            seriesName: `${scaledObj.label}`,
            opposite: opposite,
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: "#999"
            },
            labels: {
              style: {
                fontSize: '9px',
                fontWeight: 400,
                fontFamily: 'Arial',
                colors: ['#999', '#999', '#999', '#999', '#999', '#999', '#999', '#999', '#999', '#999']
              },
              formatter: (value) => { return value }
            },
            title: {
              text: `${scaledObj.unitStr}`,
              style: {
                fontSize: '9px',
                fontWeight: 400,
                fontFamily: 'Arial',
                color: '#999'
              }
            },
            tooltip: {
              enabled: false
            },
          }
          this.chartOptions.yaxis.push(ydataset);

          tmpObj.valueMin = Math.min(...tmpObj.data).toFixed(2);
          tmpObj.valueMax = Math.max(...tmpObj.data).toFixed(2);
          tmpObj.valueAvg = tmpObj.data.reduce((acc, v, i, a) => acc + v / a.length, 0).toFixed(2);

          const tooltip = {
            index: node.index,
            formatter: function (val) {
              return `<span class="fg-lightAmber">${val}</span> <span class="fg-amber text-xs">${scaledObj.unitStr}</span> <span class="text-xs fg-gray">[<span class="fg-lightBlue">${tmpObj.valueMin}</span> <span class="fg-lightOrange">${tmpObj.valueAvg}</span> <span class="fg-lightRed">${tmpObj.valueMax}</span>]</span>`;
            }
          }
          this.chartOptions.tooltip.y.push(tooltip);
          
          let department = '';
          if (scaledObj.department && scaledObj.department !== '00') {
            department = `[${scaledObj.department}] `;
          }
          tmpObj.name = `${department}${scaledObj.label}`;
          tmpObj.unit = `${scaledObj.unitStr}`;
          tmpObj.key = `${node.key}`;
          tmpObj.identifier = `${scaledObj.server}@${scaledObj.identifier}`;
          tmpObj.department = `${scaledObj.department}`;
          tmpObj.type = `area`;
          tmpObj.index = node.index;
          // console.log(tmpObj);
          this.chartSeries.push(tmpObj);
          // this.loading = false;
        } else {
          const tmpObj = {
              name: ``,
              connectNulls: true,
              data: []
          };
          console.log(key);
          tmpObj.name = `${key}`;
          tmpObj.unit = ``;
          tmpObj.key = `${key}`;
          tmpObj.department = ``;
          tmpObj.type = `line`;
          tmpObj.index = 0;
          this.chartSeries.push(tmpObj);
          // this.loading = false;
        }
      });
    },
    changeDate(startDate, dateTime) {
      let dateTimeFormat, dateTimeSelectStart, dateTimeSelectEnd;
      const offset = (this.hoursOffset * 60 * 60 * 1000);

      if (dateTime && typeof(dateTime) === 'object') {
        dateTimeFormat = dateTime.format;
        dateTimeSelectStart = dateTime.start;
        dateTimeSelectEnd = dateTime.end;
        // this.hoursOffset = 0;
        if (this.dialogState.date) this.hideDialog('date');
      } else {
        dateTimeFormat = '%d.%m.%Y - %H:%Mh';
      }

      if (startDate === '12h') {
				dateTimeSelectStart = new Date(Date.now() - (12 * 60 * 60 * 1000));
        this.dateTime.window = '2m';
			}
      else if (startDate === '24h') {
				dateTimeSelectStart = new Date(Date.now() - (24 * 60 * 60 * 1000));
        this.dateTime.window = '10m';
			}
      else if (startDate === '48h') {
				dateTimeSelectStart = new Date(Date.now() - (2 * 24 * 60 * 60 * 1000));
        this.dateTime.window = '30m';
			}
      else if (startDate === '7d') {
				dateTimeSelectStart = new Date(Date.now() - (7 * 24 * 60 * 60 * 1000));
				dateTimeFormat = '%d.%m.%Y - %H:';
        this.dateTime.window = '60m';
			}
      else if (startDate === '30d') {
				dateTimeSelectStart = new Date(Date.now() - (30 * 24 * 60 * 60 * 1000));
				dateTimeFormat = '%d.%m.%Y - %Hh';
        this.dateTime.window = '120m';
			}
      else if (startDate === '2m') {
				dateTimeSelectStart = new Date(Date.now() - (60 * 24 * 60 * 60 * 1000));
				dateTimeFormat = '%d.%m.%Y - %Hh';
        this.dateTime.window = '240m';
			}
      else if (startDate === '1y') {
				dateTimeSelectStart = new Date(Date.now() - (365 * 24 * 60 * 60 * 1000));
				dateTimeFormat = '%d.%m.%Y';
        this.dateTime.window = '12h';
			}

      if (offset > 0) {
        dateTimeSelectEnd = new Date(Date.now() - offset);
        dateTimeSelectStart = new Date(Date.now() - (offset + (24 * 60 * 60 * 1000)));
      }

			if (!dateTimeSelectEnd) dateTimeSelectEnd = new Date(Date.now());
      if (!dateTimeSelectStart) dateTimeSelectStart = new Date(Date.now() - (24 * 60 * 60 * 1000));
      const diff = dateTimeSelectEnd - dateTimeSelectStart;
      // console.log(diff);
      if (diff <= (24 * 60 * 60 * 1000)) dateTimeFormat = '%d.%m - %H:';
      else if (diff <= (2 * 24 * 60 * 60 * 1000)) dateTimeFormat = '%d.%m.%Y - %H:';
      else if (diff <= (7 * 24 * 60 * 60 * 1000)) dateTimeFormat = '%d.%m.%Y - %H:';
      else if (diff <= (30 * 24 * 60 * 60 * 1000)) dateTimeFormat = '%d.%m.%Y - %Hh';
      else if (diff <= (60 * 24 * 60 * 60 * 1000)) dateTimeFormat = '%d.%m.%Y - %Hh';
      else if (diff <= (365 * 24 * 60 * 60 * 1000)) dateTimeFormat = '%d.%m.%Y';
      this.dateTime.start = dateTimeSelectStart;
      this.dateTime.end = dateTimeSelectEnd;
      this.dateTime.format = dateTimeFormat;
      
      const dateTimeOptions = {
        day: '2-digit',
        month: '2-digit',
        year: undefined,
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      };

      this.chartOptions.xaxis = {
        type: 'datetime',
        labels: {
          formatter: function (value, timestamp) {
            return `${new Date(timestamp).toLocaleString('de-AT', dateTimeOptions)}`;
          },
          style: {
            fontSize: '11px',
            fontWeight: 400,
            fontFamily: 'Arial',
            colors: ['#999', '#999', '#999', '#999', '#999', '#999', '#999', '#999', '#999', '#999']
          }
        },
        crosshairs: {
          show: true,
          opacity: .8,
          position: 'back',
          stroke: {
            color: '#999',
            width: 2,
            dashArray: 0
          }
        },
      }

      // this.showChart1(this.value);
      this.chartSeries = [];
      this.chartOptions.yaxis = [];
      this.chartOptions.tooltip.y = [];
      this.nodeData.forEach((entry, index) => {
        entry.index = index;
        this.renderChart(entry, dateTimeSelectStart, dateTimeSelectEnd, dateTimeFormat);
      });
      // this.chartSeries.sort((a, b) => a.index - b.index);
      // console.log('ARRAY SORT');
      // console.log(this.nodeData);
      // console.log(this.chartSeries);
      // this.loading = false;
    },
    timeTravel(offset) {
      if (offset > 0) {
        this.hoursOffset = this.hoursOffset - offset;
        if (this.hoursOffset < 0) this.hoursOffset = 0;
        if (this.dateTime) this.changeDate(null, this.dateTime);
        else this.changeDate();
      } else if (offset < 0) {
        this.hoursOffset = this.hoursOffset + (offset * -1);
        if (this.dateTime) this.changeDate(null, this.dateTime);
        else this.changeDate();
      } else {
        this.hoursOffset = 0;
        this.changeDate();
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-in-enter-active {
  animation: fadeIn linear 0.3s;
}
@keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}
@keyframes fadeOut {
  0% {opacity:1;}
  100% {opacity:0;}
}
.bounce-enter-active {
    animation: bounce-in 0.5s;
    // transition: opacity .5s;
}
.bounce-leave-active {
    animation: bounce-out 0.5s;
    // transition: opacity .5s;
}
.slide-fade-enter-active {
    transition: all 0.5s ease;
}
.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
}
.pulse-enter-active {
    animation: pulse 1s;
}
.pulse-leave-active {
    animation: pulse 0.5s;
}
@keyframes pulse {
    0% {
        // transform: scale(1); /* scaling to 0 */
        opacity: 0.8;
        // color: yellowgreen;
        // transform-origin: center center;
        // transform: scaleY(.9);
        text-shadow: black 2px 0 10px;
        transform: scale(0.9); /* increasing the size */
    }
    30% {
        transform: scale(1.1); /* increasing the size */
        text-shadow: gray 1px 0 10px;
    }
    100% {
        transform: scale(1); /* seeting back to initial size */
        opacity: 1;
    }
}
.grid {
    margin: 0 -0.5em 0 -0.5em !important;
}
.col {
    // line-height: 1.4em !important;
    margin: 0 !important;
    padding: 0 !important;
}
.p-divider {
    margin: 0 !important;
    padding: 0 !important;
}
.box {
    padding: 0.1em !important;
    text-align: center;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    // text-shadow: 1px 1px 1px black;
}
.box p {
    overflow-wrap: break-word;
    hyphens: auto;
}
.card {
    font-family: 'SensorFont';
    line-height: 1.3rem;
    position: relative;
    height: 100%;
    padding: 0.3em;
}
.text-normal {
    line-height: 0;
}
.menu-overlay {
    top: 0px;
    right: 0px;
    position: absolute;
    height: 100px;
    opacity: 0;
    transition: 0.2s ease;
    background: none;
    text-align: right;
}
.card:hover .menu-overlay {
    opacity: 1;
}
.menu-overlay .p-button-rounded {
    width: 2rem;
    height: 2rem;
}
// .list-enter-active,
// .list-leave-active {
//   transition: all 0.5s ease;
//   transform: scale(0.7); /* increasing the size */
// }
// .list-enter-from,
// .list-leave-to {
//   opacity: 0;
//   transform: scale(1); /* increasing the size */
// }
.list-enter-active {
    animation: list 1s;
}
.list-leave-active {
    animation: list 0.5s;
}
@keyframes list {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

</style>